// File: src/pages/ManagerDashboard.jsx
import React, { useState } from 'react';
import { Box, Typography, Button, TextField, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Divider } from '@mui/material';

/** Manager Dashboard:
 * a) List of users, can remove, can add manually
 * b) Add content to blog
 * c) concurrency stats
 */
const ManagerDashboard = () => {
  const [users, setUsers] = useState([
    { id: 1, name: 'John Doe', role: 'user', email: 'john@example.com' },
    { id: 2, name: 'Jane Smith', role: 'manager', email: 'jane@example.com' },
    { id: 3, name: 'Alice', role: 'user', email: 'alice@example.com' },
  ]);

  const [newUserName, setNewUserName] = useState('');
  const [newUserEmail, setNewUserEmail] = useState('');

  // Hard-coded concurrency stats
  const concurrencyStats = {
    year: 2400,
    month: 650,
    week: 130,
    today: 25,
    yesterday: 20,
  };

  const handleAddUser = () => {
    if (!newUserName || !newUserEmail) return;
    const newUser = {
      id: Date.now(),
      name: newUserName,
      role: 'user',
      email: newUserEmail,
    };
    setUsers([...users, newUser]);
    setNewUserName('');
    setNewUserEmail('');
  };

  const handleRemoveUser = (id) => {
    const updated = users.filter((u) => u.id !== id);
    setUsers(updated);
  };

  const handleAddBlogContent = () => {
    alert('Add content to Community Blog - placeholder');
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Manager Dashboard
      </Typography>

      {/* Concurrency Stats */}
      <Box sx={{ display: 'flex', gap: 3, my: 2, flexWrap: 'wrap' }}>
        <Paper sx={{ p: 2, flex: '1 1 auto', minWidth: 180 }}>
          <Typography variant="h6">Yearly Traffic</Typography>
          <Typography variant="body1">{concurrencyStats.year}</Typography>
        </Paper>
        <Paper sx={{ p: 2, flex: '1 1 auto', minWidth: 180 }}>
          <Typography variant="h6">Monthly Traffic</Typography>
          <Typography variant="body1">{concurrencyStats.month}</Typography>
        </Paper>
        <Paper sx={{ p: 2, flex: '1 1 auto', minWidth: 180 }}>
          <Typography variant="h6">Weekly Traffic</Typography>
          <Typography variant="body1">{concurrencyStats.week}</Typography>
        </Paper>
        <Paper sx={{ p: 2, flex: '1 1 auto', minWidth: 180 }}>
          <Typography variant="h6">Today</Typography>
          <Typography variant="body1">{concurrencyStats.today}</Typography>
        </Paper>
        <Paper sx={{ p: 2, flex: '1 1 auto', minWidth: 180 }}>
          <Typography variant="h6">Yesterday</Typography>
          <Typography variant="body1">{concurrencyStats.yesterday}</Typography>
        </Paper>
      </Box>

      <Divider sx={{ my: 3 }} />

      {/* Add Content to Community Blog */}
      <Box sx={{ mb: 3 }}>
        <Typography variant="h6" gutterBottom>
          Add Content to Community Blog
        </Typography>
        <Button variant="contained" onClick={handleAddBlogContent}>
          Add Blog Post
        </Button>
      </Box>

      <Divider sx={{ my: 3 }} />

      {/* Manage Users */}
      <Typography variant="h6" gutterBottom>
        Manage Users
      </Typography>
      <Box sx={{ display: 'flex', gap: 2, my: 2 }}>
        <TextField
          label="Name"
          value={newUserName}
          onChange={(e) => setNewUserName(e.target.value)}
        />
        <TextField
          label="Email"
          value={newUserEmail}
          onChange={(e) => setNewUserEmail(e.target.value)}
        />
        <Button variant="contained" onClick={handleAddUser}>
          Add User
        </Button>
      </Box>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Role</TableCell>
              <TableCell>Email</TableCell>
              <TableCell align="right">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {users.map((u) => (
              <TableRow key={u.id}>
                <TableCell>{u.name}</TableCell>
                <TableCell>{u.role}</TableCell>
                <TableCell>{u.email}</TableCell>
                <TableCell align="right">
                  <Button
                    variant="outlined"
                    sx={{ mr: 1 }}
                    onClick={() => handleRemoveUser(u.id)}
                  >
                    Remove
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default ManagerDashboard;
